export const CREATE_ASSET = '[Assets] Create Asset';
export const CREATE_ASSET_SUCCESS = '[Assets] Create Asset Success';
export const CREATE_ASSET_ERROR = '[Assets] Create Asset Error';

export const REPLACE_ASSET = '[Assets] Replace Asset';
export const REPLACE_ASSET_SUCCESS = '[Assets] Replace Asset Success';
export const REPLACE_ASSET_ERROR = '[Assets] Replace Asset Error';

export const GET_ASSET_STATUS = '[Assets] Get Asset Status';
export const GET_ASSET_STATUS_SUCCESS = '[Assets] Get Asset Status Success';
export const GET_ASSET_STATUS_ERROR = '[Assets] Get Asset Status Error';

export const START_ASSET_UPLOAD = '[Assets] Start Upload Asset';
export const UPDATE_ASSET_UPLOAD = '[Assets] Update Upload Asset';
export const FINISH_ASSET_UPLOAD = '[Assets] Finish Upload Asset';
export const FINISH_ASSET_REPLACE_UPLOAD =
  '[Assets] Finish Asset Replace Upload';
export const CANCEL_ASSET_UPLOAD = '[Assets] Cancel Upload Asset';
export const REMOVE_ASSET_UPLOAD = '[Assets] Remove Upload Asset';

export const CLEAR_ASSETS = '[Assets] Clear assets';
